import { render, staticRenderFns } from "./CampaignNewForm.vue?vue&type=template&id=4649dd3b&scoped=true&"
import script from "./CampaignNewForm.vue?vue&type=script&lang=js&"
export * from "./CampaignNewForm.vue?vue&type=script&lang=js&"
import style0 from "./CampaignNewForm.vue?vue&type=style&index=0&id=4649dd3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649dd3b",
  null
  
)

export default component.exports